var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMassage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "100px",
    height: "100px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    display: "none"
  }, /*#__PURE__*/React.createElement("g", {
    display: "inline"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.057,49.997c-0.04-0.249-0.036-0.505,0.015-0.76c0.032-0.169,0.085-0.33,0.155-0.482l3.273-7.58 c1.564-3.623,4.379-8.438,10.746-8.438h4.367c6.365,0,9.182,4.815,10.744,8.438l3.293,7.627c0.475,1.094-0.031,2.366-1.125,2.839 c-1.096,0.474-2.366-0.031-2.84-1.127l-3.293-7.625c-1.789-4.142-3.752-5.832-6.779-5.832h-4.367c-3.028,0-4.992,1.69-6.781,5.832 l-1.99,4.61h4.671c1.193,0,2.16,0.967,2.16,2.16s-0.967,2.158-2.16,2.158h-7.9c-0.019,0.002-0.038,0.002-0.058,0.002 c-0.181,0-0.363-0.021-0.544-0.069c-0.184-0.047-0.358-0.119-0.519-0.211c-0.327-0.185-0.589-0.445-0.776-0.749 C36.203,50.551,36.102,50.283,36.057,49.997L36.057,49.997z M87.957,84.704h-0.99V66.326c0-1.193-0.967-2.161-2.16-2.161H49.683 c-1.193,0-2.16,0.968-2.16,2.161c0,1.191,0.967,2.158,2.16,2.158h32.963v16.22h-0.989c-1.192,0-2.159,0.967-2.159,2.16 c0,1.192,0.967,2.159,2.159,2.159h3.086c0.022,0.002,0.043,0.002,0.063,0.002c0.022,0,0.043,0,0.064-0.002h3.086 c1.193,0,2.16-0.967,2.16-2.159C90.117,85.671,89.15,84.704,87.957,84.704L87.957,84.704z M43.422,20.482 c0-4.966,4.041-9.007,9.008-9.007s9.006,4.041,9.006,9.007c0,4.966-4.039,9.007-9.006,9.007S43.422,25.448,43.422,20.482 L43.422,20.482z M47.743,20.482c0,2.584,2.103,4.686,4.687,4.686c2.584,0,4.688-2.102,4.688-4.686 c0-2.585-2.104-4.688-4.688-4.688C49.845,15.794,47.743,17.898,47.743,20.482L47.743,20.482z M96.104,63.37l-2.604-5.772 c-0.074-0.182-0.173-0.351-0.293-0.503c-0.127-0.165-0.274-0.308-0.44-0.427c-0.263-0.188-0.566-0.318-0.896-0.375 c-0.139-0.023-0.282-0.035-0.426-0.031H37.141c-0.25-0.008-0.499,0.03-0.742,0.113c-0.164,0.055-0.319,0.129-0.461,0.221 c-0.316,0.197-0.565,0.469-0.736,0.777c-0.135,0.241-0.224,0.512-0.256,0.799c-0.029,0.246-0.017,0.499,0.042,0.746 c0.049,0.205,0.126,0.4,0.229,0.578l11.668,21.388l0.005,3.55c0.001,1.191,0.968,2.157,2.159,2.157h0.003 c1.194-0.002,2.159-0.97,2.157-2.163l-0.005-4.059c0.004-0.189-0.019-0.383-0.065-0.571c-0.05-0.19-0.123-0.37-0.218-0.536 L40.73,60.582h49.375l2.061,4.562c0.488,1.088,1.77,1.571,2.855,1.082C96.109,65.736,96.594,64.458,96.104,63.37L96.104,63.37z  M35.177,66.326c0,1.191-0.967,2.158-2.16,2.158H16.398v16.22h0.989c1.193,0,2.16,0.967,2.16,2.16c0,1.192-0.967,2.159-2.16,2.159 h-3.085c-0.021,0.002-0.042,0.002-0.063,0.002c-0.022,0-0.043,0-0.064-0.002h-3.086c-1.193,0-2.16-0.967-2.16-2.159 c0-1.193,0.967-2.16,2.16-2.16h0.99V66.326c0-1.193,0.968-2.161,2.161-2.161h1.112c-1.295-1.56-2.073-3.562-2.073-5.742 c0-4.967,4.04-9.007,9.006-9.007c4.966,0,9.007,4.04,9.007,9.007c0,2.181-0.779,4.183-2.073,5.742h3.798 C34.21,64.165,35.177,65.133,35.177,66.326L35.177,66.326z M26.972,58.423c0-2.585-2.103-4.688-4.688-4.688 c-2.584,0-4.687,2.104-4.687,4.688c0,2.584,2.102,4.687,4.687,4.687S26.972,61.007,26.972,58.423L26.972,58.423z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M42.65,22.166c0,4.501,3.663,9.324,8.164,9.324c4.502,0,8.165-4.823,8.165-9.324c0-4.504-3.665-8.166-8.165-8.166 C46.313,14,42.65,17.664,42.65,22.166L42.65,22.166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M43.148,53.309h-8.535c4.007-9.753,7.474-17.244,11.322-17.244h10.277c3.849,0,9.755,13.413,11.148,17.42"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M8.368,57.296c0,4.276,3.48,7.755,7.755,7.755c4.278,0,9.896-3.479,9.896-7.755s-5.621-7.759-9.896-7.759 C11.847,49.54,8.368,53.02,8.368,57.296L8.368,57.296z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: " 41.581,86 41.581,80.774 30.813,59.29 90.064,59.29 92.678,65.215  "
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M31.71,72.064H10.226c-1.604,0-2.903-1.3-2.903-2.903l0,0c0-1.604,1.3-2.903,2.903-2.903h19.161"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#6D6F71",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: " M34.613,66.258h49.354c1.604,0,2.903,1.3,2.903,2.903l0,0c0,1.604-1.3,2.903-2.903,2.903H36.936"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMassage);
export default __webpack_public_path__ + "static/media/massage.ee74c9720adf3442cc94d1bf7d8e9168.svg";
export { ForwardRef as ReactComponent };